import { BiExit } from "react-icons/bi";
import { FaGasPump } from "react-icons/fa";
import { IoLocationSharp } from "react-icons/io5";
import type { FuelLocation } from "./api";

// InfoWindow content component for consistent styling
const InfoWindowContent = ({ place }: { place: FuelLocation }) => (
    <div className="p-1.5 min-w-[200px]">
        <div className="flex items-center mb-1">
            <IoLocationSharp className="text-orange-600 mr-1 flex-shrink-0" />
            <p className="font-medium text-gray-900 text-sm">{place.location}</p>
        </div>
        <div className="flex items-center mb-1 text-gray-600 text-xs">
            <BiExit className="mr-1 text-xs flex-shrink-0" />
            <span>{place.interstate_exit}</span>
        </div>
        <div className="flex items-center text-xs">
            <FaGasPump className="text-red-600 mr-1 flex-shrink-0" />
            <span>
                {place.fuelToPurchase === -99 ? "Top off tractor at" : `Purchase ${place.fuelToPurchase} gallons at`}
                &nbsp;
                <span className="bg-green-100 border border-green-200 px-1 py-0.5 rounded text-green-800 text-xs font-medium">
                    {place.price.toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                    })}{" "}
                    / gal
                </span>
            </span>
        </div>
    </div>
);

export default InfoWindowContent;
